import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-wmt-popover',
  templateUrl: './wmt-popover.component.html',
  styleUrls: ['./wmt-popover.component.scss'],
})
export class WmtPopoverComponent {
  @Input() deliveryDetails: {
    isDelivered: boolean;
    deliveryDate: Date;
    start: Date;
    end: Date;
  };

  //for delivered orders, use order header delivery details
  @Input() orderHeaderDeliveryDetails: {
    deliveredDtm: Date;
    orderDelivered: boolean;
  };
}
